<nav
  aria-label="navigation"
  class="py-xl bg-white"
  [style.direction]="!isInLanding() ? 'ltr' : ''">
  <div
    [style.max-width]="!isInLanding() ? '100%' : '1440px'"
    class="nav-content-container flex justify-between items-center px-lg md:px-6xl">
    <!-- Logo -->
    @let dashboardRoute =
      '/' + (authService.userType()?.user + '/' + Path.DASHBOARD | navigation);
    @let homeRoute = '/' + (Path.HOME | navigation);
    @let logoNavigation =
      !isInLanding()
        ? authService.isLoggedIn()
          ? dashboardRoute
          : homeRoute
        : homeRoute;
    <a [routerLink]="logoNavigation">
      <mars-logo />
    </a>

    <!-- links -->
    @if (isInLanding()) {
      <ul class="font-medium gap-4xl hidden text-center text-small xl:flex">
        @for (link of navbarLinks; track link.label) {
          <li>
            <a
              class="text-primary-900"
              [routerLink]="'/' + (link.path | navigation)"
              routerLinkActive="active-route">
              {{ link.label }}
            </a>
          </li>
        }
      </ul>
    }

    <!-- lang -->
    <div class="flex items-center gap-lg">
      @if (isInLanding()) {
        <button
          type="button"
          (click)="switchLanguage()"
          class="flex gap-sm items-center">
          <mars-globe-icon />
          <span class="text-small font-[Graphik_Arabic]">{{
            lang() === 'en' ? 'عربي' : 'EN'
          }}</span>
        </button>

        <!-- Action Buttons -->
        @if (!authService.isLoggedIn()) {
          <div class="hidden md:flex gap-md">
            <a
              [routerLink]="'/' + (Path.LOGIN | navigation)"
              class="border border-neutral-300 cursor-pointer font-medium md:text-small px-xl py-sm rounded-sm text-medium text-neutral-700">
              {{ 'top_navbar_login_button_label' | transloco }}
            </a>
            <a
              [routerLink]="'/' + (Path.SIGN_UP_ACCOUNT_INFO | navigation)"
              class="bg-primary-900 cursor-pointer font-medium md:text-small px-xl py-sm rounded-sm text-medium text-white">
              {{ 'top_navbar_sign_up_button_label' | transloco }}
            </a>
          </div>
        }
      }
      @if (authService.isLoggedIn()) {
        <mars-user-info
          (logout)="logout()"
          [isLoggingOut]="isLoggingOut()"
          [showDropdown]="isLoggingOut()" />
      }

      <!-- menu side mobile nav -->
      @if (isInLanding()) {
        <button
          (click)="toggleMobileNavbar()"
          type="button"
          class="inline-block xl:hidden">
          @if (!isMobileNavbarOpened) {
            <mars-hamburger-menu-icon class="inline-block" />
          }

          @if (isMobileNavbarOpened) {
            <mars-close-menu-icon class="inline-block" />
          }
        </button>
      }
    </div>
  </div>
</nav>

@if (isMobileNavbarOpened && isInLanding()) {
  <nav class="xl:hidden block mobile-navbar" aria-label="Site mobile menu">
    <div class="mb-xl">
      <!-- links -->
      <ul
        class="flex flex-col font-medium gap-4xl px-2xl text-center text-medium">
        @if (isInLanding()) {
          @for (link of navbarLinks; track link.label) {
            <li>
              <a
                class="text-primary-500"
                (click)="isMobileNavbarOpened = false"
                [routerLink]="'/' + (link.path | navigation)"
                routerLinkActive="active-route">
                {{ link.label }}
              </a>
            </li>
          }
        }

        <!-- Action Buttons -->
        <li class="block md:hidden">
          <div class="flex justify-between gap-md">
            @if (!authService.isLoggedIn()) {
              <a
                [routerLink]="'/' + (Path.LOGIN | navigation)"
                class="border border-neutral-300 cursor-pointer font-medium md:text-small px-xl py-sm rounded-sm text-medium text-neutral-700 w-full">
                {{ 'top_navbar_login_button_label' | transloco }}
              </a>
              <a
                [routerLink]="'/' + (Path.SIGN_UP | navigation)"
                class="bg-primary-900 cursor-pointer font-medium md:text-small px-xl py-sm rounded-sm text-medium text-white w-full">
                {{ 'top_navbar_sign_up_button_label' | transloco }}
              </a>
            } @else {
              <div class="w-full flex flex-col gap-md">
                <a
                  (click)="logout()"
                  class="bg-primary-500 cursor-pointer font-medium md:text-small px-xl py-sm rounded-sm text-medium text-white w-full">
                  Logout
                </a>
              </div>
            }
          </div>
        </li>
      </ul>
    </div>
  </nav>
}
